module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJnbHlwaGljb25zLWhhbGZsaW5ncy1yZWd1bGFyLjg5ODg5Njguc3ZnIjs="


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 858
// module chunks = 1